
// ROUTES
require('modules/event/routes/event');

// CONTROLLERS
require('modules/event/controllers/event');
require('modules/event/controllers/event_texts');
require('modules/event/controllers/years');
require('modules/event/controllers/list');
require('modules/event/controllers/detail');
require('modules/event/controllers/create');
require('modules/event/controllers/edit');
require('modules/event/controllers/site');
require('modules/event/controllers/send');


// SERVICES
require('modules/event/services/event');
require('modules/event/services/list');
require('modules/event/services/create');
require('modules/event/services/edit');
require('modules/event/services/delete');
require('modules/event/services/site');
require('modules/event/services/send');


angular.module('unica_event', [

	// ROUTES
	'unica_event.event_routes',

	// CONTROLLERS
	'unica_event.event_controllers',

	// SERVICES
	'unica_event.event_services'

]);